import React from 'react';

class AboutMe extends React.Component {
  render() {
    return (
    <div className="about-me">
      <p className="content-title"><span>i</span>ntroduction</p>
      <div className="content-article content-article-paragraphs">
        <p>
          Hello! I'm Kyungmin Kim, a Full-stack Software Engineer based in Las Vegas, Nevada, and authorized to work in the U.S. 
          I've spent years building and maintaining web applications across a range of industries, 
          and I care most about software that is reliable, maintainable, and scalable, grounded in a clear 
          understanding of the business it serves.
        </p>
        <p>
          I enjoy untangling complex problems, improving development processes, and constantly refining 
          the way I build software. Lately, I've been especially interested in AI-assisted development and 
          how it is reshaping the way engineers design, build, and solve problems.
        </p>
        <p>
          I believe great software comes from strong technical skills, real business understanding, 
          and good communication. Outside of work, I enjoy running and spending time with my family. :)
        </p>
      </div>
      <div className="row about-me-img-box">
        <img className="about-me-img" src={require('./../images/about-me-etc03.jpeg')} alt="Kyungmin Kim" />
      </div>
      <p className="content-title"><span>e</span>ducation</p>
      <div className="content-article">
        <p>• (2016) B.S. in Computer Science, Korea University</p>
        <p>• Graduated with Honors (GPA: 4.00)</p>
      </div>
      <p className="content-title"><span>s</span>kill set</p>
      <div className="content-article">
        <p>• Infra</p>
        <div className="about-me-skill-list">
          <p className="u-level-05">AWS</p>
          <p className="u-level-04">Nginx</p>
          <p className="u-level-04">CI/CD</p>
          <p className="u-level-03">Docker</p>
          <p className="u-level-01">IIS</p>
        </div>
        <p>• Back-end & DB</p>
        <div className="about-me-skill-list">
          <p className="u-level-05">Node.js</p>
          <p className="u-level-05">Next.js</p>
          <p className="u-level-05">TypeScript</p>
          <p className="u-level-05">MongoDB</p>
          <p className="u-level-05">MySQL</p>
          <p className="u-level-04">Express</p>
          <p className="u-level-04">PHP</p>
          <p className="u-level-04">Yii2</p>
          <p className="u-level-03">ASP.NET</p>
          <p className="u-level-03">MSSQL</p>
          <p className="u-level-03">Firebase</p>
        </div>
        <p>• Front-end</p>
        <div className="about-me-skill-list">
          <p className="u-level-05">React</p>
          <p className="u-level-05">jQuery</p>
          <p className="u-level-04">React Native</p>
          <p className="u-level-04">CSS</p>
          <p className="u-level-04">Sass</p>
          <p className="u-level-02">Angular 2</p>
          <p className="u-level-02">Ionic 2</p>
          <p className="u-level-02">LESS</p>
          <p className="u-level-01">Cordova</p>
        </div>
      </div>
      {/* <p className="content-title"><span>r</span>eason why you should NOT hire me</p>
      <div className="content-article">
        <p>• Limited experience: Task management tool such as Webpack and Grunt etc., in toy project, <span className="u-color-red">only</span></p>
        <p>• I Love to use AWS services, but not having experience to handle massive logs and setting delicate log systems, <span className="u-color-red">yet</span></p>
        <p>• Having knowledge of Docker, but no experience of using Kubernetes, <span className="u-color-red">yet</span></p>
        <p>• Not having experience to use Kafka, <span className="u-color-red">yet</span></p>
      </div>
      <p className="content-title"><span>h</span>owever,</p>
      <div className="content-article">
        <p>• I am eager to learn things what solve problems and consistently say coding is my passion.</p>
      </div> */}
      <p className="content-title"><span>c</span>ontact</p>
      <div className="content-article content-final">
        <p>primetrm@gmail.com</p>
      </div>
    </div>
    );
  }
}

export default AboutMe;
